import axios, { AxiosError } from 'axios';
import { EGerdauService } from './EGerdauService';

export const customersAuthorizationApi = axios.create({
  baseURL: process.env.REACT_APP_CUSTOMER_AUTHORIZATION
    ? process.env.REACT_APP_CUSTOMER_AUTHORIZATION
    : ''
});

customersAuthorizationApi.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error: AxiosError) => {
    EGerdauService.treatAxiosError(error);
    return Promise.reject(error);
  }
);

export enum ECustomerAuthorizationEndpoints {
  VALIDATE = '/validate',
  USERS = '/users',
  CUSTOMERS = '/customers',
  LOGOUT = '/logout',
  CREATE_PASSWORD = '/users/password',
  SEND_NPS = '/users/survey/nps',
  SEND_JORNEY_SHEET = '/users/survey/spreadsheet',
  SEND_JORNEY_SELECTING_ITEMS = '/users/survey/selecting_items',
  SEND_JORNEY_HISTORY = '/users/survey/history',
  SEND_JORNEY_SHOWCASE = '/users/survey/showcase',

  OPEN_ORDER_STATUS = '/items/dashboard/open',
  DUPLICATES = '/invoices/dashboard-hana',
  BILLED_BY_MONTH = '/items/dashboard/billed-month',
  PAID_BY_MONTH = '/invoices/dashboard-payment-month',
  BILLED_BY_DAY = '/items/dashboard/billed-by-day',
  DUPLICATES_BY_DAY = '/invoices/dashboard-payment-month-day',
  TRACKING_FLAT_STEEL = 'items/flatsteel-status',
  TRACKING_FLAT_STEEL_EXCEL = 'items/flatsteel-status/excel',
  TRACKING_LONG_STEEL = 'items/long-steel-tracking-data',
  BILLED_ORDER_TRACKING = '/tracking-orders',
  OPEN_ORDER_STATUS_BY_SKU = '/items/dashboard/open',
  VALIDATE_ORDERS_TO_UPDATE = '/items/sales-orders-change-validation',
  ORDER_CHANGE_DATA = '/items/sales-orders-change-data',
  EDIT_ITEMS = '/items/edit',
  USER_CUSTOMER_MANAGEMENTE = '/customer-management',

  CREDIT_LIMITS = '/credit-limits',
  INVOICE_CREDITS = '/invoices/credits',
  INVOICES = '/invoices',
  RENEW_CREDIT_LIMITS = '/credit-limits/renew',
  RENEW_CREDIT_LIMITS_DOCS = '/credit-limits/renew/docs',
  BILLETS = '/billets',

  EMITTER_OPEN_ORDERS = '/items/sold-to-open',
  EMITTER_BILLED_ORDERS = '/items/sold-to-billed',
  RECEIVER_OPEN_ORDERS = '/items/ship-to-open',
  RECEIVER_BILLED_ORDERS = '/items/ship-to-billed',

  REPORT_ORDERS_DOWNLOAD = '/reports/open-orders',

  SEARCH_ITEM = '/entry-order/text',
  SEARCH_ITEM_SHEET = '/entry-order/sheet',
  PRODUCT_DESCRIPTION = '/entry-order/products-description',
  PRODUCT_DESCRIPTION_V2 = '/entry-order/products-description-v2',
  PRODUCT_FOR_CUSTOMER = 'search/_sql',
  BLOCKS = '/customers/blocks',
  SEND_ORDER = '/entry-order',
  SEND_ORDER_V2 = '/entry-order-v2',
  LAST_ORDERS = '/entry-order/last-orders',
  PURCHASE_RECEIVERS = '/entry-order/shipto-customers',
  PAYMENT_CONDITIONS = '/entry-order/payment-conditions',

  GENERATE_BILLING = '/generate-billing',
  DOWNLOAD_CQ_FILE = '/qc-file',
  GENERATE_CQ = '/generate-qc',
  MULTIPLE_CQ = '/cq-multi',
  GENERATE_NF_XML = '/nfe-xml-file',

  // Comercial Gerdau
  DELIVERY_QC = '/qc-file-cg',

  // Corte e dobra (fabrication)
  CONTRACTS = '/cd-contracts',
  CONTRACTS_V2 = '/v2/cd-contracts',
  CONTRACTS_HEADERS = '/cd-contracts-headers',
  CONTRACTS_HEADERS_V2 = '/v2/cd-contracts-headers',
  PIECE_TYPES = '/piece-type',
  STEEL_TYPES = '/steel-type',
  DIAMETER = '/diameter', // bitola
  ANNEALED_WIRE_TYPES = '/annealed-wire-type',
  PROJECTS = '/projects',
  MOCKUPS = '/mockups',
  PAVEMENTS = '/pavements',
  FABRICATION_ORDER_ENTRY = '/order/entry',
  FABRICATION_ORDER_PDF_DOWNLOAD = 'order/:id/download',
  FABRICATION_ORDER = 'order/fabrication-order',
  SEND_CONSTRUCTION_REGISTRATION = '/logistics',

  // LOYALTY
  LOYALTY_REWARD = '/loyalty/reward',
  LOYALTY_HISTORY = '/loyalty/history',
  LOYALTY_GOAL = '/loyalty/goal',
  LOYALTY_PRODUCT = '/loyalty/simulator/item-complement',
  LOYALTY_PRODUCT_SIMULATE = '/loyalty/simulator/send-itens',
  LOYALTY_WITHDRAW = '/loyalty/withdrawalParams',
  LOYALTY_SEND_WITHDRAW = '/loyalty/withdraw',

  HELP_MENU = '/support-material',

  //SELLER-JOURNEY
  SALES_REPRESENTATIVE = '/sales-representative',
  SALES_REP_CODES = '/customers/sales-rep-codes',

  // MARKETING-CLOUD
  SEND_MKT_CLOUD_EVENT = '/web-event-to-mkt-cloud',

  // CHECKOUT
  CARTS = '/commerce/carts',
  ORDER_SIMULATE = '/entry-order/order-simulate',

  // PRODUCTS
  PRODUCTS = '/commerce/products',
  CATEGORIES = '/commerce/categories'
}
